import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import arSa from '@worktango/translations/survey/ar-sa.json';
import bgBg from '@worktango/translations/survey/bg-bg.json';
import csCz from '@worktango/translations/survey/cs-cz.json';
import daDk from '@worktango/translations/survey/da-dk.json';
import deDe from '@worktango/translations/survey/de-de.json';
import elGr from '@worktango/translations/survey/el-gr.json';
import enCa from '@worktango/translations/survey/en-ca.json';
import enUs from '@worktango/translations/survey/en-us.json';
import esEs from '@worktango/translations/survey/es-es.json';
import fiFi from '@worktango/translations/survey/fi-fi.json';
import frCa from '@worktango/translations/survey/fr-ca.json';
import frFr from '@worktango/translations/survey/fr-fr.json';
import hiIn from '@worktango/translations/survey/hi-in.json';
import hrHr from '@worktango/translations/survey/hr-hr.json';
import huHu from '@worktango/translations/survey/hu-hu.json';
import idId from '@worktango/translations/survey/id-id.json';
import itIt from '@worktango/translations/survey/it-it.json';
import jaJp from '@worktango/translations/survey/ja-jp.json';
import jpJp from '@worktango/translations/survey/jp-jp.json';
import koKr from '@worktango/translations/survey/ko-kr.json';
import ltLt from '@worktango/translations/survey/lt-lt.json';
import msMy from '@worktango/translations/survey/ms-my.json';
import myMm from '@worktango/translations/survey/my-mm.json';
import nbNo from '@worktango/translations/survey/nb-no.json';
import nlNl from '@worktango/translations/survey/nl-nl.json';
import paIn from '@worktango/translations/survey/pa-in.json';
import plPl from '@worktango/translations/survey/pl-pl.json';
import ptBr from '@worktango/translations/survey/pt-br.json';
import ptPt from '@worktango/translations/survey/pt-pt.json';
import roRo from '@worktango/translations/survey/ro-ro.json';
import ruRu from '@worktango/translations/survey/ru-ru.json';
import soSo from '@worktango/translations/survey/so-so.json';
import sqAl from '@worktango/translations/survey/sq-al.json';
import srRs from '@worktango/translations/survey/sr-rs.json';
import svSe from '@worktango/translations/survey/sv-se.json';
import thTh from '@worktango/translations/survey/th-th.json';
import tlPh from '@worktango/translations/survey/tl-ph.json';
import trTr from '@worktango/translations/survey/tr-tr.json';
import zhCn from '@worktango/translations/survey/zh-cn.json';
import zhTw from '@worktango/translations/survey/zh-tw.json';

const options = {
  // order from where user language should be detected
  order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    returnEmptyString: false,
    fallbackLng: 'en-CA',
    ns: ['translations'],
    defaultNS: 'translations',
    debug: false,
    resources: {
      'ar-SA': arSa,
      'bg-BG': bgBg,
      'cs-CZ': csCz,
      'da-DK': daDk,
      'de-DE': deDe,
      'el-GR': elGr,
      'en-CA': enCa,
      'en-US': enUs,
      'es-ES': esEs,
      'fi-FI': fiFi,
      'fr-CA': frCa,
      'fr-FR': frFr,
      'hi-IN': hiIn,
      'hr-HR': hrHr,
      'hu-HU': huHu,
      'id-ID': idId,
      'it-IT': itIt,
      'ja-JP': jaJp,
      'jp-JP': jpJp,
      'ko-KR': koKr,
      'lt-LT': ltLt,
      'ms-MY': msMy,
      'my-MM': myMm,
      'nb-NO': nbNo,
      'nl-NL': nlNl,
      'pa-IN': paIn,
      'pl-PL': plPl,
      'pt-BR': ptBr,
      'pt-PT': ptPt,
      'ro-RO': roRo,
      'ru-RU': ruRu,
      'so-SO': soSo,
      'sq-AL': sqAl,
      'sr-RS': srRs,
      'sv-SE': svSe,
      'th-TH': thTh,
      'tl-PH': tlPh,
      'tr-TR': trTr,
      'zh-CN': zhCn,
      'zh-TW': zhTw,
    },
    lng: 'en-CA',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format) => {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      },
    },
  });

export default i18n;
